import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import ShippingMethod from './shipping_method';
import Information from './information';
import Payment from './payment';
import CashAppRedirect from './cash_app_redirect';
import PaymentOption from './payment_option';
import Review from './review';
import OfferSelect from './offer_select';
import FinanceApp from './finance_app';
import Complete from './complete';

const Main = () => (
  <Switch>
    <Route path="/information" component={Information} />
    <Route path="/shipping_method" component={ShippingMethod} />
    <Route path="/payment_option" component={PaymentOption} />
    <Route path="/offer_select" component={OfferSelect} />
    <Route path="/finance_app" component={FinanceApp} />
    <Route path="/payment" component={Payment} />
    <Route path="/cash_app_pay" component={CashAppRedirect} />
    <Route path="/review" component={Review} />
    <Route path="/complete" component={Complete} />
    <Redirect to="/information" />
  </Switch>
);

export default Main;
